import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Box } from '@openfin/ui-library';

import { NotificationList } from '../NotificationList/NotificationList';
import { RootState } from '../../../store/State';
import { EmptyResultsListCard, LoadingCard } from '../Cards/Cards';

type Props = ReturnType<typeof mapState>;

const SearchResultComponent: React.FC<Props> = (props) => {
  const { results, searching, query } = props;
  return (
    <Container className="searchResults" flexDirection="column">
      {searching && <LoadingCard message="Fetching results" />}
      {!searching && results.length === 0 && <EmptyResultsListCard query={query} />}
      {results.length > 0 && <NotificationList notifications={results} />}
    </Container>
  );
};

const Container = styled(Box)`
  width: calc(100% + 4px);
  flex: 1;
`;

const mapState = (state: RootState) => ({
  results: state.search.results,
  searching: state.search.searching,
  query: state.search.query,
  applications: state.applications,
});

export const SearchResults = connect(mapState)(SearchResultComponent);
